/* eslint-disable react/prop-types */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../../../../tooltip';
import Button, { ButtonSizes, ButtonTypes } from '../../../../button';

const TooltipButton = React.memo(({
  id, disabled, type, onClick, label, renderIcon, className, borderLess, description,
  buttonBadgeProps,
}) => {
  const onClickCallback = useCallback(() => onClick(id), [id, onClick]);

  const getButton = () => (
    <Button
      key={id}
      id={id}
      label={label}
      type={type}
      renderIcon={renderIcon}
      disabled={disabled}
      className={className}
      borderLess={borderLess}
      size={ButtonSizes.SMALL}
      onClick={onClickCallback}
      badgeProps={buttonBadgeProps}
    />
  );

  return description ? <Tooltip description={description}>{getButton()}</Tooltip> : getButton();
});

TooltipButton.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  borderLess: PropTypes.bool,
  className: PropTypes.string,
  description: PropTypes.string,
  renderIcon: PropTypes.func,
  type: PropTypes.oneOf(Object.values(ButtonTypes)),
  buttonBadgeProps: PropTypes.shape(Button.propTypes.badgeProps),
};

TooltipButton.defaultProps = {
  id: '',
  label: '',
  renderIcon: null,
  disabled: false,
  description: '',
  borderLess: false,
  onClick: () => {},
  className: 'tbl-button',
  type: ButtonTypes.PRIMARY,
  buttonBadgeProps: Button.defaultProps.badgeProps,
};

export default TooltipButton;
